var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.6227V17.5663C0.0643977 17.1829 0.139528 16.7995 0.193193 16.4161C0.80011 12.113 2.8473 8.14695 5.99672 5.17276C9.14613 2.19856 13.2094 0.394129 17.5156 0.0574254C21.8217 -0.279278 26.1133 0.871885 29.6815 3.32082C33.2497 5.76976 35.8811 9.37 37.1414 13.527C37.5331 14.8393 37.7209 16.2271 38 17.5663V20.6227C37.9446 20.7793 37.9016 20.9399 37.8712 21.1033C37.4791 24.943 35.9402 28.573 33.4571 31.5151C30.974 34.4572 27.6633 36.5731 23.9613 37.5842C23.3281 37.757 22.6734 37.8596 22.0133 38V24.6835H26.3923L27.2241 19.1431H21.9596C21.9596 17.9443 21.9596 16.8157 21.9596 15.6925C21.9596 13.7376 22.9846 12.6954 24.9112 12.636C25.7215 12.636 26.5211 12.636 27.4012 12.636V7.80301C25.7591 7.71661 24.1491 7.56001 22.566 7.56001C20.9953 7.53101 19.4708 8.09558 18.2935 9.14228C17.1162 10.189 16.3716 11.6418 16.2068 13.2138C16.0697 14.5646 16.0159 15.9226 16.0458 17.2801C16.0458 17.8903 16.0458 18.4951 16.0458 19.1809H11.2696V24.7267H15.9921V37.9676C15.8356 37.9584 15.6797 37.9404 15.5252 37.9136C8.18387 36.2936 3.26818 31.9196 0.874735 24.7483C0.503509 23.3914 0.211432 22.0139 0 20.6227Z",
    fill: "#E41F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9d99bff7ae41df2f50686e5deefbd84b.svg";
export { ForwardRef as ReactComponent };